(function () {
  const btn = document.getElementById("scrollToTop");

  if (!btn) return;

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  );
  const isMobileViewport = window.matchMedia("(max-width: 768px)");

  let ticking = false;
  let isVisible = false;

  function updateVisibility() {
    if (isMobileViewport.matches) {
      isVisible = true;
      btn.classList.add("visible");
      ticking = false;
      return;
    }

    const scrollY = window.scrollY;
    const vh = window.innerHeight;

    // Trigger visibility when the user has scrolled more than 2 viewport heights, and hide it when they scroll back up within 1 viewport height.
    if (!isVisible && scrollY > vh * 2) {
      isVisible = true;
      btn.classList.add("visible");
    } else if (isVisible && scrollY < vh) {
      isVisible = false;
      btn.classList.remove("visible");
    }

    ticking = false;
  }

  function onScroll() {
    if (isMobileViewport.matches) {
      return;
    }

    if (!ticking) {
      requestAnimationFrame(updateVisibility);
      ticking = true;
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  updateVisibility();

  btn.addEventListener("click", function (e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion.matches ? "auto" : "smooth",
    });
    
    // Set focus to the top element for accessibility
    const topElement = document.getElementById("top");
    if (topElement) {
      // Ensure the element is focusable
      if (!topElement.hasAttribute("tabindex")) {
        topElement.setAttribute("tabindex", "-1");
      }
      // Focus after scroll completes
      setTimeout(() => {
        topElement.focus();
      }, prefersReducedMotion.matches ? 0 : 300);
    }
  });
})();
